import { createSlice } from "@reduxjs/toolkit";

export const VendorSlice = createSlice({
    name: 'vendorSlice',
    initialState: {
        allVendor: [],
        allVendorWithPagination: {
            total_page_count: 1,
            data: []
        }
    },
    reducers: {
        // get all vendor reducer
        getAllVendorReducer: (state, action) => {
            state.allVendor = action.payload
        },
        // get all vendor with pagination
        getAllVendorWithPaginationReducer: (state, action) => {
            state.allVendorWithPagination = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        }
    }
})